import 'jquery';
import 'es6-promise/auto';
import { Amplitude } from '../Shared/amplitude';

export default function initProjectPropertyModals(ClassicEditor: any) {
	const projectName = $('#project-name').val();

	$('.btn-edit-project-property').click(function (e) {
		const $this = $(this);
		const modalId = $this.data('target');
		const propertyName = $this.data('property');

		const $modal = $(modalId);

		$modal.modal({
			focus: false,
			show: false,
			backdrop: 'static'
		});

		$modal.modal('show');
	});

	$('.project-property-modal').each(function () {
		const $modal = $(this);
		let $currentValue = $modal.find('.project-property-value');
		let $originalValue = $modal.find('.project-property-original-value');
		let editor: any = null;

		$modal.on('show.bs.modal', () => {
			ClassicEditor.default.create($currentValue.get(0), {
				toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'insertTable', 'undo', 'redo'],
				heading: {
					options: [
						{ model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
						{ model: 'heading5', view: 'h5', title: 'Title', class: 'ck-heading_heading5' },
						{ model: 'heading6', view: 'h6', title: 'Subtitle', class: 'ck-heading_heading6' }
					]
				},
				table: {
					toolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
				}
			})
				.then((instance: any) => {
					instance.setData($originalValue.val());
					editor = instance;
				});
		});

		$modal.on('shown.bs.modal', function (e) {
			$modal.find('.project-property-form').on('submit', function (e) {
				e.preventDefault();

				if (editor) {
					$currentValue.val(editor.getData());
					$originalValue.val(editor.getData());
				}

				var $this = $(this);
				$.ajax({
					url: $this.attr('action'),
					type: "POST",
					data: $(this).serialize(),
					success: function (data) {
						var modalId = $this.data('modal');

						var $markdown = $('.btn-edit-project-property[data-target="' + modalId + '"]').parent().find('.property-markdown');
						$markdown.empty().html(data);

						$modal.modal('hide');

						const propertyName = $this.data('property');
						const projectName = $('#project-name').val();

						const isDeal = !!$('#deal-key').val();
						const eventName = isDeal ? 'Deal - Property - Edit' : 'Project - Property - Edit';

						Amplitude.logEvent(eventName, {
							'Project': projectName,
							'Property': propertyName
						});
					},
					error: function (jXHR, textStatus, errorThrown) { }
				});
			});
		});

		$modal.on('hidden.bs.modal', function (e) {
			if (editor != null) {
				editor.destroy();
				editor = null;
			}
		});
	});
}